// frontend/src/lib/queryClient.js
//
// Shared @tanstack/react-query client for the app.
//
// Wave 1 note: this only introduces the client + provider (wired in App.js).
// No existing fetch has been converted to useQuery yet — that migration
// happens in a later wave. Defaults below are chosen so that when call sites
// are migrated, master data (users/teams/appointment types/cost centers) is
// deduplicated and cached for a few minutes instead of refetched per page.

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Master data changes rarely; keep it fresh for a few minutes so that
      // multiple components mounting on the same page share one request.
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export default queryClient;
